var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCirclePlaceholder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0555 0.611328C11.1853 0.611328 0.722168 11.0745 0.722168 23.9447C0.722168 36.8148 11.1853 47.278 24.0555 47.278C36.9257 47.278 47.3888 36.8148 47.3888 23.9447C47.3888 11.0745 36.9257 0.611328 24.0555 0.611328ZM24.0555 43.0043C13.5432 43.0043 4.99585 34.4569 4.99585 23.9447C4.99585 13.4324 13.5432 4.88501 24.0555 4.88501C34.5678 4.88501 43.1152 13.4324 43.1152 23.9447C43.1152 34.4569 34.5678 43.0043 24.0555 43.0043Z",
    fill: "#8D9091"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1643 18.4921C30.7107 18.4921 31.9643 17.2385 31.9643 15.6921C31.9643 14.1457 30.7107 12.8921 29.1643 12.8921C27.6179 12.8921 26.3643 14.1457 26.3643 15.6921C26.3643 17.2385 27.6179 18.4921 29.1643 18.4921Z",
    fill: "#8D9091"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6695 22.8638C31.0309 21.9796 29.7046 21.9796 29.066 22.8638L27.9853 24.3375C27.7888 24.6322 27.2976 24.6322 27.1011 24.3375L22.4835 17.9024C21.8449 17.0182 20.5186 17.0182 19.88 17.9024L12.0204 29.0042C11.2835 30.0357 12.0204 31.5094 13.2976 31.5094H34.7642C36.0414 31.5094 36.8274 30.0357 36.0414 29.0042L31.6695 22.8638Z",
    fill: "#8D9091"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclePlaceholder);
export default __webpack_public_path__ + "static/media/circle-placeholder.13f73056f8c921fdf21fab142f4be916.svg";
export { ForwardRef as ReactComponent };